
import Button from '../../../components/base/Button';

export default function UpcomingEventsSection() {
  const events = [
    {
      title: "Annual CPVA Conference 2025",
      date: "March 15-17, 2025",
      location: "Toronto Convention Centre",
      type: "Conference",
      attendees: "1,200+ Expected",
      description: "Join Canada's premier healthcare collaboration event featuring keynote speakers, workshops, and networking opportunities.",
      image: "https://public.readdy.ai/ai/img_res/904f85e8b7256f95caf682587eb1cead.jpg",
      price: "Early Bird: $399",
      featured: true
    },
    {
      title: "Veterinary Pharmacology Webinar",
      date: "February 8, 2025",
      location: "Online",
      type: "Webinar",
      attendees: "500+ Registered",
      description: "Advanced training on companion animal drug therapy and emerging veterinary medications.",
      image: "https://readdy.ai/api/search-image?query=Online%20veterinary%20education%20webinar%2C%20professional%20presenting%20on%20screen%2C%20veterinary%20pharmacology%20training%2C%20digital%20learning%20environment%20for%20veterinarians&width=400&height=200&seq=event2&orientation=landscape",
      price: "Free for Members"
    },
    {
      title: "Mental Health Workshop Series",
      date: "February 12, 2025",
      location: "Vancouver, BC",
      type: "Workshop",
      attendees: "150 Available Spots",
      description: "Interactive workshop focusing on burnout prevention and mental wellness for healthcare professionals.",
      image: "https://readdy.ai/api/search-image?query=Mental%20health%20workshop%20for%20healthcare%20professionals%2C%20group%20therapy%20session%2C%20wellness%20training%20environment%2C%20supportive%20healthcare%20setting&width=400&height=200&seq=event3&orientation=landscape",
      price: "$125"
    },
    {
      title: "One Health Policy Summit",
      date: "February 20, 2025",
      location: "Ottawa, ON",
      type: "Summit",
      attendees: "300+ Policy Makers",
      description: "High-level discussion on integrated health policies connecting human, animal, and environmental health.",
      image: "https://readdy.ai/api/search-image?query=Government%20policy%20summit%20meeting%2C%20healthcare%20policy%20makers%20in%20discussion%2C%20professional%20conference%20room%2C%20policy%20development%20session&width=400&height=200&seq=event4&orientation=landscape",
      price: "$275"
    },
    {
      title: "Rural Health Innovation Forum",
      date: "March 5, 2025",
      location: "Winnipeg, MB",
      type: "Forum",
      attendees: "200+ Rural Practitioners",
      description: "Collaborative solutions for healthcare delivery in rural and remote Canadian communities.",
      image: "https://readdy.ai/api/search-image?query=Rural%20healthcare%20professionals%20meeting%2C%20small%20town%20medical%20discussion%2C%20rural%20health%20innovation%2C%20healthcare%20collaboration%20in%20rural%20setting&width=400&height=200&seq=event5&orientation=landscape",
      price: "$150"
    },
    {
      title: "Digital Health Technology Showcase",
      date: "March 10, 2025",
      location: "Calgary, AB",
      type: "Showcase",
      attendees: "400+ Tech Enthusiasts",
      description: "Latest innovations in healthcare technology, AI applications, and digital health solutions.",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20technology%20showcase%2C%20medical%20technology%20exhibition%2C%20digital%20health%20innovations%2C%20modern%20tech%20display%20for%20healthcare%20professionals&width=400&height=200&seq=event6&orientation=landscape",
      price: "$195"
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Upcoming Events
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join us at upcoming conferences, workshops, and educational events designed to advance your professional development.
          </p>
        </div>
        
        {/* Featured Event */}
        <div className="mb-12">
          <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              <div className="p-8 lg:p-12 text-white">
                <div className="flex items-center mb-4">
                  <span className="bg-yellow-400 text-yellow-900 px-3 py-1 rounded-full text-sm font-bold mr-3">
                    FEATURED EVENT
                  </span>
                  <span className="text-blue-100">{events[0].type}</span>
                </div>
                <h3 className="text-3xl font-bold mb-4">{events[0].title}</h3>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center">
                    <i className="ri-calendar-line mr-3"></i>
                    {events[0].date}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-map-pin-line mr-3"></i>
                    {events[0].location}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line mr-3"></i>
                    {events[0].attendees}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-price-tag-3-line mr-3"></i>
                    {events[0].price}
                  </div>
                </div>
                <p className="text-blue-100 mb-6">{events[0].description}</p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Button className="bg-white text-blue-900 hover:bg-gray-100">
                    Register Now
                  </Button>
                  <Button variant="outline" className="border-white text-white hover:bg-white hover:text-blue-900">
                    View Agenda
                  </Button>
                </div>
              </div>
              <div className="hidden lg:block">
                <img
                  src={events[0].image}
                  alt={events[0].title}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
        
        {/* Other Events */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {events.slice(1).map((event, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
              <img
                src={event.image}
                alt={event.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm font-medium text-blue-600 bg-blue-100 px-3 py-1 rounded-full">
                    {event.type}
                  </span>
                  <span className="text-sm font-semibold text-gray-900">{event.price}</span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {event.title}
                </h3>
                
                <div className="space-y-2 mb-4 text-sm text-gray-600">
                  <div className="flex items-center">
                    <i className="ri-calendar-line mr-2"></i>
                    {event.date}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-map-pin-line mr-2"></i>
                    {event.location}
                  </div>
                  <div className="flex items-center">
                    <i className="ri-group-line mr-2"></i>
                    {event.attendees}
                  </div>
                </div>
                
                <p className="text-gray-600 mb-4">
                  {event.description}
                </p>
                
                <div className="flex gap-3">
                  <Button size="sm">
                    Register
                  </Button>
                  <Button variant="outline" size="sm">
                    Details
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            Don't see what you're looking for? Check out our full events calendar.
          </p>
          <Button size="lg" variant="outline">
            View Full Calendar
          </Button>
        </div>
      </div>
    </section>
  );
}
